import {
  Paper,
  Typography,
  Stack,
  Box,
  useTheme,
  Tooltip,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
} from "@mui/material";

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Dangerous,
  Error,
  LocalFireDepartment,
  MoreVert,
  ReplyAll,
  ReportProblem,
} from "@mui/icons-material";
import ModalAcknowledge from "../../modalAcknowledge";
import { useMapa } from "../../../../contexts/mapaContext";
import usePermissao from "../../../../hooks/usePermissao";

export default function CardAlerts(props) {
  const {
    alert,
    setFocusNodeId,
    isScrolling,
    selectionMode = false,
    isSelected = false,
    onToggleSelect = () => {},
  } = props;
  const { isPublic = false } = useMapa();
  const { canEdit } = usePermissao("easyMaps");
  const theme = useTheme();
  const [typeCard, setTypeCard] = useState({});
  const [openAcknowledgeModal, setOpenAcknowledgeModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    function type() {
      return alert?.severity == 2
        ? {
            cor: theme.palette.color.zabbixSeverty.warning,
            icon: (
              <ReportProblem
                sx={{
                  color: theme.palette.color.zabbixSeverty.warning,
                  fontSize: "26px",
                }}
              />
            ),
            title: "Alerta",
          }
        : alert?.severity == 3
          ? {
              cor: theme.palette.color.zabbixSeverty.average,
              icon: (
                <Error
                  sx={{
                    color: theme.palette.color.zabbixSeverty.average,
                    fontSize: "26px",
                  }}
                />
              ),
              title: "Alerta Moderado",
            }
          : alert?.severity == 4
            ? {
                cor: theme.palette.color.zabbixSeverty.high,
                icon: (
                  <Dangerous
                    sx={{
                      color: theme.palette.color.zabbixSeverty.high,
                      fontSize: "26px",
                    }}
                  />
                ),
                title: "Alerta de alto impacto",
              }
            : {
                cor: theme.palette.color.zabbixSeverty.disaster,
                icon: (
                  <LocalFireDepartment
                    sx={{
                      color: theme.palette.color.zabbixSeverty.disaster,
                      fontSize: "26px",
                    }}
                  />
                ),
                title: "Alerta de Desastre",
              };
    }
    setTypeCard(type());
  }, [alert]);

  const handleOpenAcknowledgeModal = (event) => {
    event.stopPropagation();
    event.preventDefault();

    setOpenAcknowledgeModal(true);
    setAnchorEl(null);
  };

  const handleCardClick = () => {
    if (selectionMode) {
      onToggleSelect(alert?.eventid);
    } else {
      setFocusNodeId(alert?.elementId);
    }
  };

  const styles = {
    title: {
      fontSize: "0.9em",
      maxWidth: "220px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      textAlign: "left",
    },
    message: {
      fontSize: "0.8em",
      maxWidth: "220px",
      textAlign: "left",
      WebkitLineClamp: 2,
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      color: theme.palette.color.textDisabled,

      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    line: {
      backgroundColor: typeCard.cor,
      height: "80%",
      width: "2px",
      right: 0,
      position: "absolute",
    },
    card: {
      backgroundColor: isSelected
        ? `${typeCard.cor}33`
        : alert?.severity == 5 || alert?.severity > 4
          ? `${typeCard.cor}2a`
          : theme.palette.background.paperSelectedMaps,
      boxShadow:
        alert?.severity == 5 || alert?.severity > 4
          ? `0px 0px 10px ${typeCard.cor}`
          : alert?.severity == 4
            ? `0px 0px 5px ${typeCard.cor}80`
            : "0px 0px 5px  #0000001a",
      border: isSelected
        ? `2px solid ${typeCard.cor}`
        : alert?.severity == 5 || alert?.severity > 4
          ? `1px solid ${typeCard.cor}`
          : alert?.severity == 4
            ? `1px solid ${typeCard.cor}90`
            : "1px solid transparent",
      position: "relative",
      width: "100%",
      padding: "15px 10px",
      pl: "15px",
      display: "flex",
      direction: "row",
      height: "90px",
      alignItems: "center",
      gap: 2,
      "&:hover": {
        backgroundColor:
          alert?.severity == 5 || alert?.severity > 4
            ? `${typeCard.cor}33`
            : theme.palette.background.hover,
      },
    },
    buttonCard: {
      color: "inherit",
      padding: "15px 10px",
      display: "flex",
      direction: "row",
      justifyContent: "flex-start",
      width: "100%",
      height: "100%",
      gap: 1.5,
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },
    },
    pulse: {
      position: "absolute",
      zIndex: 0,
      left: "50%",
      top: "50%",
      transform: "translateX(-50%) translateY(-50%)",
      width: { xs: "13px", md: "18px" },
      height: { xs: "13px", md: "18px" },
      "&:before": {
        content: '""',
        position: "relative",
        display: "block",
        width: "300%",
        height: "300%",
        boxSizing: "border-box",
        marginLeft: "-100%",
        marginTop: "-100%",
        borderRadius: "50%",
        backgroundColor: typeCard.cor,
        animation: "pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite",
      },

      "@keyframes pulse-ring": {
        "0%": {
          transform: "scale(.33)",
        },
        "80%, 100%": {
          opacity: 0,
        },
      },
      "@keyframes pulse-dot": {
        "0%": {
          transform: "scale(.8)",
        },
        "50%": {
          transform: "scale(1)",
        },
        "100%": {
          transform: "scale(.8)",
        },
      },
    },
  };

  return (
    <>
      <Tooltip title={alert?.name} placement="left">
        <Button
          onClick={handleCardClick}
          sx={{
            padding: "0px",
            width: isScrolling ? "97%" : "100%",
          }}
        >
          <Paper elevation={0} sx={styles.card}>
            <Stack
              sx={{
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectionMode ? (
                <Checkbox
                  checked={isSelected}
                  onChange={() => onToggleSelect(alert?.eventid)}
                  onClick={(e) => e.stopPropagation()}
                  sx={{ color: typeCard.cor, p: 0 }}
                  size="small"
                />
              ) : (
                <>
                  {typeCard.icon}
                  {alert.isNew && <Box sx={styles.pulse} />}
                </>
              )}
            </Stack>

            <Stack direction="column" alignItems="start">
              <Typography sx={styles.title}>
                {typeCard?.title?.toUpperCase()}
              </Typography>
              <Typography sx={[styles.message, { mt: "-3px", mb: "2px" }]}>
                {dayjs(new Date(alert?.lastchange * 1000)).format(
                  "DD/MM/YYYY HH:mm",
                )}
              </Typography>
              <Tooltip title={alert?.event_name}>
                <Typography sx={styles.message}>{alert?.event_name}</Typography>
              </Tooltip>
            </Stack>

            {!isPublic && canEdit && !selectionMode && (
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  setAnchorEl(event.currentTarget);
                }}
                size="small"
                sx={{
                  position: "absolute",
                  right: "4px",
                  top: "4px",
                  color: theme.palette.color.icon,
                }}
              >
                <MoreVert />
              </IconButton>
            )}
          </Paper>
        </Button>
      </Tooltip>

      {!selectionMode && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
        >
          <MenuItem
            onClick={(event) => {
              handleOpenAcknowledgeModal(event);
            }}
            sx={{ display: "flex", gap: "8px" }}
          >
            <ReplyAll sx={{ fontSize: "20px" }} /> Reconhecer Alerta
          </MenuItem>
        </Menu>
      )}

      {!selectionMode && (
        <ModalAcknowledge
          key={"ack" + alert?.eventid}
          open={!isPublic && canEdit && openAcknowledgeModal}
          onClose={() => setOpenAcknowledgeModal(false)}
          alertData={alert || null}
        />
      )}
    </>
  );
}
